<template>
	<div class="ccontainer__checkbox">
		<label class="container__checkbox__label">
			<input
				:id="id"
				type="checkbox"
				:value="value"
				:checked="checked"
				:disabled="disabled"
				@input="change($event)"
			/>
			<span :class="['container__checkbox__custom', color]" />
			<div
				:id="id"
				:title="label"
				class="container__checkbox__label text"
			>
				{{ label }}
			</div>
		</label>
	</div>
</template>

<script>
export default {
	model: {
		prop: 'checked',
	},
	props: {
		id: String,
		checked: Boolean,
		label: String,
		disabled: Boolean,
		value: String,
		color: {
			type: String,
			default: 'trv-default',
			validator: (value) => {
				return ['trv-default', 'trv-primary'].indexOf(value) !== -1
			},
		},
	},
	methods: {
		change(e) {
			this.$emit('input', e.target.checked)
			this.$emit('click', e)
		},
	},
}
</script>

<style scoped>
.ccontainer__checkbox {
	width: auto;
	min-width: 1rem;
	height: 1rem;
	display: flex;
}

.container__checkbox__label {
	display: block;
	position: relative;
	cursor: pointer;
	width: fit-content;
	user-select: none;
	overflow: hidden;
	white-space: nowrap;
}

.text {
	text-overflow: ellipsis;
}

.container__checkbox__label input {
	position: absolute;
	cursor: pointer;
	display: none;
}

.container__checkbox__label .container__checkbox__custom {
	position: absolute;
	left: 0px;
	height: 1rem;
	width: 1rem;
	background-color: transparent;
	transition: all 0.3s ease-out;
	-webkit-transition: all 0.3s ease-out;
	-moz-transition: all 0.3s ease-out;
	-ms-transition: all 0.3s ease-out;
	-o-transition: all 0.3s ease-out;
	border: 2px solid #e4e4e5;
	border-radius: 5px;
}

.container__checkbox__label .container__checkbox__custom.trv-primary {
	border: 2px solid rgba(var(--color-primary), 0.8);
}

input:disabled ~ .container__checkbox__custom {
	cursor: not-allowed;
}

.container__checkbox__label input:checked ~ .container__checkbox__custom {
	-webkit-transform: rotate(0deg) scale(1);
	-ms-transform: rotate(0deg) scale(1);
	transform: rotate(0deg) scale(1);
	opacity: 1;
}

.container__checkbox__label input:checked ~ .container__checkbox__custom.trv-default {
	background-color: var(--color-green);
	border: 2px solid var(--color-green);
}

.container__checkbox__label input:checked ~ .container__checkbox__custom.trv-primary {
	background-color: rgb(var(--color-primary));
	border: 2px solid rgb(var(--color-primary));
}

.container__checkbox__label .container__checkbox__custom::after {
	position: absolute;
	content: '';
	height: 0px;
	width: 0px;
	border: solid white;
	border-width: 0 3px 3px 0;
	-webkit-transform: rotate(0deg) scale(0);
	-ms-transform: rotate(0deg) scale(0);
	transform: rotate(0deg) scale(0);
	opacity: 1;
}

.container__checkbox__label input:checked ~ .container__checkbox__custom::after {
	-webkit-transform: rotate(45deg) scale(1);
	-ms-transform: rotate(45deg) scale(1);
	transform: rotate(45deg) scale(1);
	opacity: 1;
	left: 0.25rem;
	bottom: 0.12rem;
	width: 0.31rem;
	height: 0.62rem;
	border: solid white;
	border-width: 0 2px 2px 0;
	background-color: transparent;
	border-radius: 0;
}

.container__checkbox__label input ~ .container__checkbox__label {
	font-size: 0.75rem !important;
	margin-left: 1.25rem;
	color: rgb(var(--color-primary)) !important;
}

.container__checkbox__label input:checked ~ .container__checkbox__label {
	color: var(--color-navy-blue);
}

input:disabled {
	cursor: not-allowed;
}
</style>
